module.exports = __webpack_public_path__ + "static/media/19ESCAP15.e9b3b065.jpg";